import app from '../../../api/app'

const state = {
  info:{}
}

const actions = {
  getApplication({commit}, appId) {
    app.getApplication(appId).then((data) => {
      commit('applicationInfo', data.result)
    });
  }
}

const getters = {
  appInfo: state => state.info
}

const mutations = {
  ['applicationInfo'](state, result) {
    state.info=result;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/common/vuex/modules/app/appInfo.js